const RingingAvatar = () => {
  return (
    <div className="relative w-[109px] h-[109px] mb-3.5">
      <div className="absolute flex justify-center items-center w-[109px] h-[109px] pt-1.5">
        <img
          className="w-[56px] h-[56px] absolute z-50"
          width="56px"
          height="56px"
          src={'./svg/ringing-avatar.svg'}
          alt="avatar"
        />
      </div>
      <div className="absolute flex justify-center items-center w-[109px] h-[109px]">
        <div
          style={{
            animation:
              'scale-animation-65-100 0.7s alternate-reverse infinite ease',
          }}
          className="bg-gradient-to-br from-[#E8A872] to-[#EF567E] rounded-full opacity-70 w-[68px] h-[68px] absolute"
        />
      </div>
      <div className="absolute flex justify-center items-center w-[109px] h-[109px]">
        <div
          style={{
            animation:
              'scale-animation-65-100 0.7s alternate-reverse infinite ease',
          }}
          className="bg-gradient-to-br from-[#E8A872] to-[#EF567E] rounded-full w-[90px] h-[90px] absolute opacity-30"
        />
      </div>
      <div className="absolute flex justify-center items-center w-[109px] h-[109px]">
        <div
          style={{
            animation:
              'scale-animation-65-100 0.7s alternate-reverse infinite ease',
          }}
          className="bg-gradient-to-br from-[#E8A872] to-[#EF567E] rounded-full opacity-10 w-[109px] h-[109px]"
        />
      </div>
    </div>
  )
}

export default RingingAvatar
